import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import "./DashboardHeader.css";

const DashboardHeader = ({ hideUser = false }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/signin");
  };

  // Get user info from localStorage
  let showName = "";
  const authUserInfo = (() => {
    try { return JSON.parse(localStorage.getItem("auth_user_info")); }
    catch { return null; }
  })();

  if (authUserInfo) {
    if (authUserInfo.type === 1) {
      showName = authUserInfo.name || "";
    } else if (authUserInfo.type === 2) {
      showName = (authUserInfo.fname + " " + (authUserInfo.lname || "")).trim();
    }
  }

  return (
    <header className="app-top">
      <div className="app-top__inner">
        {/* Left: Brand logo */}
        <div className="app-top__left">
          <a href="/dashboard" className="app-top__brand">
            <img
              src="/assets/images/Ramzan_Logo_3-removebg-preview.png"
              alt="Ramzan Scholarship"
              className="app-top__logo-img"
            />
            <span className="app-top__brand-name">Ramzan Scholarship Program</span>
          </a>
        </div>

        {/* Right: Saved indicator + User avatar dropdown */}
        <div className="app-top__right">
          <span className="app-top__saved" id="topSaved">✓ Draft saved</span>

          {!hideUser && authUserInfo && (
            <Dropdown>
              <Dropdown.Toggle as="span" className="app-top__user-toggle">
                <img
                  className="app-top__avatar"
                  src="/assets/images/faces/1.jpg"
                  alt={showName}
                  id="userDropdown"
                  onError={(e) => { e.target.style.display = "none"; }}
                />
                <span className="app-top__uname">{showName}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu align="end">
                <div className="dropdown-header">
                  <i className="i-Lock-User me-1"></i> {showName}
                </div>
                <Dropdown.Item onClick={handleLogout}>
                  Sign out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
